import { LuX } from 'react-icons/lu'

import messageStyles from '@/feature/observatory/components/ObservatoryPage.module.css'

import { CloseActionProps } from '../../GeoFenceCreateEdit.types'

export const MapMessage = ({ closeAction }: CloseActionProps) => (
  <div className={messageStyles.mapMessage} data-testid="geofence-map-message">
    <span className={messageStyles.mapMessageText}>
      Create or edit Geofence by searching address or coordinates, then set on map
    </span>
    <button
      type="button"
      className={messageStyles.mapMessageButton}
      onClick={closeAction}
      data-testid="geofence-map-message-close"
    >
      <LuX size="16" />
      <span>Close</span>
    </button>
  </div>
)
